import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PraxisComponent } from './praxis.component';
import { MaterialModule } from '../../../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PraxisRoutingModule } from './praxis-routing.module';
import { PipeModule } from '../../../pipe/pipe.module';
import { SolicitarPageComponent } from './pages/solicitar-page/solicitar-page/solicitar-page.component';
import { LayoutComponent } from './pages/layout-page/layout.component';
import { CotizacionComponent } from './pages/cotizacion-page/cotizacion.component';
import { ContratarComponent } from './pages/contratar-page/contratar.component';
import { SharedModule } from '../../../shared/shared-module.module';


@NgModule({
  declarations: [PraxisComponent, SolicitarPageComponent, LayoutComponent, CotizacionComponent, ContratarComponent],
  imports: [
    CommonModule,
    MaterialModule,
    PraxisRoutingModule,
    ReactiveFormsModule,
    PipeModule,
    SharedModule
  ]
})
export class PraxisModule { }
